export default __webpack_public_path__ + "static/media/devika-olkar.27137481.PNG";